import { api } from "../.."
import { subscriptionsCustomerURL } from "../../../../api"
import { CustomerInfo, CustomerInfoRequest } from "./types"

// Define a service using a base URL and expected endpoints
export const customerInfo = api.injectEndpoints({
	endpoints: (builder) => ({
		fetchCustomerInfo: builder.query<CustomerInfo, void>({
			query: () => subscriptionsCustomerURL(),
			providesTags: ["CustomerInfo"],
		}),

		createCustomerInfo: builder.mutation<CustomerInfo, CustomerInfoRequest>({
			query: (body) => ({
				url: subscriptionsCustomerURL(),
				method: "POST",
				body,
			}),
			invalidatesTags: ["CustomerInfo", "Payments"],
		}),

		updateCustomerInfo: builder.mutation<CustomerInfo, CustomerInfoRequest>({
			query: (body) => ({
				url: subscriptionsCustomerURL(),
				method: "PUT",
				body,
			}),
			invalidatesTags: ["CustomerInfo", "Payments"],
		}),
	}),
})

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
	useFetchCustomerInfoQuery,
	useCreateCustomerInfoMutation,
	useUpdateCustomerInfoMutation,
} = customerInfo
